function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_66",
    "data-name": "Layer 66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.09,38.68a7.39,7.39,0,0,0-5.81,2.83L25.06,33.89a7.13,7.13,0,0,0,0-3.78l15.22-7.62C44.5,28,53.53,24.91,53.5,17.91A7.4,7.4,0,1,0,38.94,19.8L23.72,27.42C19.5,22,10.47,25,10.5,32s9,10,13.22,4.58L38.94,44.2a7.42,7.42,0,0,0,7.15,9.3C55.9,53.15,55.9,39,46.09,38.68Z",
    id: "id_101",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.ad8cfc4e74badd8e8c3ae71f5bc84c52.svg";
export { ForwardRef as ReactComponent };